<template>
    <transition :name="shadow.type" @afterEnter="shadowLeave" v-if="shadow.show">
        <div class="test-main test-shadow" v-html="shadow.html"></div>
    </transition>
</template>
<script>
export default {
    props: ['shadow'],
    data(){
        return{

        }
    },
    methods:{
        shadowLeave(){
            this.shadow.show = false
        }
    }
}
</script>
<style lang="less">
.test-shadow{
    position: absolute;
    left: 0;
    top: -1px;
    transform: translateX(0) translateY(0);
    opacity: 0;
    border: none;
    background-color: #ffffff;
    width: 100%;
}
// 向右进入
.enter-right-enter{
    opacity: 0 !important;
    transform: translateX(200px) translateY(0) !important;
}
.enter-right-enter-active{
    transition: all .5s;
}
.enter-right-enter-to{
    transform: translateX(0) translateY(0) !important;
    opacity: 1 !important;
}
// 向右离开
.leave-right-enter{
    opacity: 1 !important;
    transform: translateX(0) translateY(0) !important;
}
.leave-right-enter-active{
    transition: all .5s;
}
.leave-right-enter-to{
    transform: translateX(200px) translateY(0) !important;
    opacity: 0 !important;
}

// 向左进入
.enter-left-enter{
    opacity: 0 !important;
    transform: translateX(-200px) translateY(0) !important;
}
.enter-left-enter-active{
    transition: all .5s;
}
.enter-left-enter-to{
    transform: translateX(0) translateY(0) !important;
    opacity: 1 !important;
}
// 向左离开
.leave-left-enter{
    opacity: 1 !important;
    transform: translateX(0) translateY(0) !important;
}
.leave-left-enter-active{
    transition: all .5s;
}
.leave-left-enter-to{
    transform: translateX(-200px) translateY(0) !important;
    opacity: 0 !important;
}

// 向上进入
.enter-top-enter{
    opacity: 0 !important;
    transform: translateX(0) translateY(-200px) !important;
}
.enter-top-enter-active{
    transition: all .5s;
}
.enter-top-enter-to{
    transform: translateX(0) translateY(0) !important;
    opacity: 1 !important;
}
// 向上离开
.leave-top-enter{
    opacity: 1 !important;
    transform: translateX(0) translateY(0) !important;
}
.leave-top-enter-active{
    transition: all .5s;
}
.leave-top-enter-to{
    transform: translateX(0) translateY(-200px) !important;
    opacity: 0 !important;
}

// 向下进入
.enter-bottom-enter{
    opacity: 0 !important;
    transform: translateX(0) translateY(200px) !important;
}
.enter-bottom-enter-active{
    transition: all .5s;
}
.enter-bottom-enter-to{
    transform: translateX(0) translateY(0) !important;
    opacity: 1 !important;
}
// 向下离开
.leave-bottom-enter{
    opacity: 1 !important;
    transform: translateX(0) translateY(0) !important;
}
.leave-bottom-enter-active{
    transition: all .5s;
}
.leave-bottom-enter-to{
    transform: translateX(0) translateY(200px) !important;
    opacity: 0 !important;
}
</style>




// WEBPACK FOOTER //
// packages/question-single/src/testShadow.vue